module.exports = __webpack_public_path__ + "static/img/right-top-row-4.05daae6e.webp";